import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import moment from 'moment'

// https://bootstrap-vue.js.org/docs/components/pagination/
import { PaginationPlugin } from 'bootstrap-vue'

Vue.config.productionTip = false

Vue.use(PaginationPlugin)

Vue.filter('formatDate', function(parmval) {
  if (parmval) {
    return moment(String(parmval)).format('DD/MM/YYYY HH:mm:ss')
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
